<template>
    <div id="cardInfo">
        <div class="section1">        
            <el-form :inline="true" ref="cardDetailsForm" @submit.native.prevent :model="cardDetailsForm" :rules="cardDetailsRules">
                <el-form-item prop="iccid">
                    <el-input v-model.trim="cardDetailsForm.iccid" @keyup.enter.native="getSimDetailInfoHandler(cardDetailsForm.iccid, $event)" placeholder="请输入卡号" v-focus clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary"  plain icon="el-icon-search" @click="getSimDetailInfoHandler(cardDetailsForm.iccid, $event)">搜索</el-button>
                </el-form-item>
            </el-form>             
        </div>
        <template v-if="showDetail">
            <div class="section2">
                <h4>卡板详情</h4>
                <el-row>
                    <el-col :span="6">
                        <!-- <el-image style="width:100px; height:100px" src="../../assets/img_yidong.png"></el-image> -->
                        <img v-if="cardInfo.supplierTypeCode == 3" style="width:120px" src="./../../assets/img_yidong.png" alt="">
                        <img v-if="cardInfo.supplierTypeCode == 4" style="width:120px" src="./../../assets/img_liantong.png" alt="">
                        <img v-if="cardInfo.supplierTypeCode == 1 || cardInfo.supplierTypeCode == 5" style="width:120px" src="./../../assets/img_dianxin.png" alt="">
                    </el-col>
                    <el-col :span="18">
                        <el-row>
                            <el-col :span="12">卡号： {{ cardInfo.iccid }}</el-col>
                            <el-col :span="12">通道： {{ cardInfo.supplierTypeName + cardInfo.alias }}</el-col>                            
                        </el-row>
                        <el-row>
                            <el-col :span="12">接入号： {{ cardInfo.intoNo }}</el-col>
                            <el-col :span="12">套餐组： {{ cardInfo.basePkgGroupName }}</el-col>
                        </el-row>
                        <el-row>
                            <!-- <el-col :span="12">卡类型： {{ cardInfo.cardTypeName }}</el-col> -->
                            <el-col :span="12">      
                                <el-col :span="12">卡状态： 
                                    <span class="font-defined dark" v-if="cardInfo.cardState == 1"> {{ cardInfo.cardStateName }}</span>
                                    <span class="font-defined green" v-else-if="cardInfo.cardState == 2">{{ cardInfo.cardStateName }}</span>
                                    <span class="font-defined red" v-else-if="cardInfo.cardState == 4"> {{ cardInfo.cardStateName }}</span>

                                    <span class="font-defined" v-else> {{ cardInfo.cardStateName }}</span>
                                </el-col>                             
                                <el-col :span="12">
                                    <el-button type="primary" size="mini" @click="updateStateHandler(cardInfo.iccid, true)">刷新</el-button>
                                </el-col>                            
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
            <div class="section3">
                <h4>套餐详情</h4>
                <div>
                    <div v-for="item in cardInfo.simPackageList" :key="item.id" style="margin-bottom:40px;">
                        <h5>{{ item.packageName }}</h5>
                        <el-row>
                            <el-col :span="7" class="progressOuter">
                                <el-progress :stroke-width="8" :percentage="item.usedFlowRate/item.flowRate *100" :show-text="false"></el-progress>
                                <div>
                                    <div class="fr">剩余：{{ decrease(fluxMtoG(item.flowRate) , fluxMtoG(item.usedFlowRate)) }}G</div>
                                    <div>已用：{{ fluxMtoG(item.usedFlowRate) }}G / {{ fluxMtoG(item.flowRate) }}G</div>        
                                </div>
                            </el-col>
                            <el-col :span="4" :offset="2">
                                已用流量：{{ fluxMtoG(item.usedFlowRate) }}G
                            </el-col> 
                            <el-col :span="4" >
                                生效时间：{{ item.startTime }}
                            </el-col>
                            <el-col :span="4">过期时间：{{ item.endTime }}</el-col>
                        </el-row>
                    </div> 
                </div>
            </div>
            <div class="section4">
                <h4>操作管理</h4>
                <div>
                    <!-- <el-button size="normal" @click="showAddPkg">添加套餐</el-button> -->
                    <!-- <el-button size="normal" @click="showToNewCardHandler">转新卡</el-button> -->
                    <el-button size="normal" @click="simDiagnosisHandler" icon="el-icon-search">刷新复机</el-button>
                    <el-button size="normal" @click="noBIndSIm" icon="el-icon-edit">机卡解绑</el-button>
                    <el-button size="normal" @click="stopSimHandler" plain icon="el-icon-s-ticket">智能停机</el-button> 
                    <el-button size="normal" @click="resetSimHandler" plain icon="el-icon-s-ticket">智能复机</el-button>
                     <el-button size="normal" @click="showAddRealNameSearch" icon="el-icon-search">实名查询 </el-button>
                </div>
            </div>
            <div class="section5">
                <h4>往期订单</h4>
                <el-table :data="tableData" border>
                    <el-table-column prop="packageName" label="套餐名称"></el-table-column> 
                    <el-table-column prop="packageTypeName" label="套餐类型"></el-table-column> 
                    <el-table-column label="套餐流量">
                        <template slot-scope="scope">
                            <span>{{ fluxMtoG(scope.row.flowRate) }}G</span>
                        </template>
                    </el-table-column> 
                    <el-table-column prop="createTime" label="订购时间"></el-table-column> 
                    <el-table-column prop="createTypeName" label="订购类型"></el-table-column> 
                    <el-table-column prop="isNextMonthName" label="生效时间"></el-table-column> 
                    <!-- <el-table-column prop="remark" label="备注"></el-table-column>  -->
                </el-table>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[15, 50, 100, 500]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination> 
            </div>
        </template>

        <el-dialog :append-to-body="true"  title="添加套餐" :visible.sync="addPkgVisible" width="600px" :close-on-click-modal="false">
            <el-form v-model="addPkgForm" label-width="100px">
                <el-form-item label="套餐名称：" prop="soldPackageId">
                    <el-radio-group v-model="addPkgForm.soldPackageId" class="pkgName">
                        <el-radio v-for="item in pkgList" :key="item.id" :label="item.id">{{ item.packageName }}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="showFlag" label="生效时间：" prop="isNextMonth">
                    <el-select v-model="addPkgForm.isNextMonth">
                        <el-option value="0" label="本月生效"></el-option>
                        <el-option value="1" label="次月生效"></el-option>
                    </el-select>
                </el-form-item>                
                <el-form-item label="备注：" prop="remark">
                    <el-input type="textarea" v-model="addPkgForm.remark" placeholder="请输入内容"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addPkgCancel">取 消</el-button>
                <el-button type="primary" @click="sureAddPkgHandle">确 定</el-button>
            </div> 
        </el-dialog> 
        <el-dialog :append-to-body="true"  title="转新卡" :visible.sync="toNewCardVisible" width="600px" :close-on-click-modal="false">
            <el-form ref="toNewCardForm" :model="toNewCardForm" :rules="toNewCardRules" label-width="120px">
                <el-form-item label="新卡ICCID号：" prop="iccid">
                    <el-input v-model.trim="toNewCardForm.iccid" clearable></el-input>
                </el-form-item>
                <el-form-item label="类型：" prop="moveType">
                    <el-radio-group v-model="toNewCardForm.moveType">
                        <el-radio label="2">仅转流量</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                    <el-input v-model.trim="toNewCardForm.remark" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="toNewCardCancel">取 消</el-button>
                <el-button type="primary" @click="sureToNewCardHandler">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {getSimDetailInfo, getOneSIMOrderList, agentAddPkg, getAgentPkgList, changePkgEndTime, toNewCard, simDiagnosis, updateState,resetSim,stopSim,getRealName} from '@/api/sim.js'
import common from '@/utils/common.js'

export default {
    data(){
        return {
            cardDetailsForm: {
                iccid: ''
            },
            showDetail: false,
            cardInfo: {
                supplierTypeCode: '',
                iccid: '',
                cardState: '', 
                supplierName: '',
                supplierTypeName:'',
                cardTypeName: '',
                alias: '',
                intoNo: '', 
                flowRatePool: '',
                basePkgGroupName: '',
                cardStateName: '',
                simPackageList: [],
            },
            tableData: [],
            currentPage: 1,
            pageSize: 15,
            total: 0,
            addPkgVisible: false,       //添加套餐
            pkgList: [],
            showFlag: true,
            addPkgForm: {
                isNextMonth: '',
                soldPackageId: '',
                remark: ''
            },
            toNewCardVisible: false,    //转新卡
            toNewCardForm: {
                iccid: '',
                moveType: '2',
                remark: ''
            },
            stateRecordVisible: false,
            'tableData-state': [],
            dayFluxVisible: false,
            'tableData-flux': [],
            cardDetailsRules: { 
                iccid: [{required:true, message: '请输入ICCID号或接入号', trigger: 'blur'}]
            },
            toNewCardRules: {
                iccid: [{required:true, validator: this.checkIccid, trigger: 'blur'}]
            }
        }
    },
    methods: {
          noBIndSIm(){            
            var data = {
                iccid: this.cardInfo.iccid
            };
            common.sysRequest("external/ctcc/no/bind", {iccid: this.cardInfo.iccid}, 'post').then(res => {
                 if(res.data.code == 200){
                    this.$message.success('解绑成功！');
                 }else{
                     this.$message.error(res.data.message);
                 }

            })            
           
        },
          stopSimHandler(){
            this.$confirm("您确定要进行停机操作吗？", "提示" ,{          
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then( () => {
                var data = {
                    iccid: this.cardInfo.iccid
                }
                stopSim(data).then( res => {
                    if(res.data.code == 200){
                        this.$message.success("停机完成！");
                        this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    }else{
                        if(res.data){
                            this.$message.error(res.data.message);
                        }
                    }                    
                })
            })
        },
            resetSimHandler(){
            this.$confirm("您确定要进行复机操作吗？", "提示" ,{          
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then( () => {
                var data = {
                    iccid: this.cardInfo.iccid
                }
                resetSim(data).then( res => {
                    if(res.data.code == 200){
                        this.$message.success("复机完成！")
                        this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    }else{
                        this.$message.error(res.data.message)
                    }                    
                })
            })
        },
            showAddRealNameSearch(){//点击电信实名查询
            let data = {
                iccid: this.cardDetailsForm.iccid,
                intoNo:this.cardInfo.intoNo
            }
            getRealName(data).then(res => {
                if(res.data.code == 200){
                    this.$alert('已实名', {
                    confirmButtonText: '确定'})
                }else{
                    this.$alert('未实名', {
                    confirmButtonText: '确定'})
                }
            })
        },
        addPkgCancel(){
            this.addPkgVisible = false;
            this.$refs.addPkgForm.resetFields();
        },
        toNewCardCancel(){
            this.toNewCardVisible = false;
            this.$refs.toNewCardForm.resetFields();
        },
        getSimDetailInfoHandler(iccid, $event){
            if($event){
                Object.assign(this.$data, this.$options.data());  //重置为初始值
                this.cardDetailsForm.iccid = iccid
            }            
            this.$refs.cardDetailsForm.validate( valid => {
                if(valid){                    
                    var data = {
                        iccid
                    }
                    getSimDetailInfo(data).then(res => {
                        if(res.data.code == 200){
                            this.showDetail = true;
                            var result = res.data;
                            for(var key in this.cardInfo){
                                this.cardInfo[key] = res.data.data[key];
                            }
                            this.$nextTick(() => {
                                this.updateStateHandler(iccid, false);  
                                this.showDetail = true;
                            })
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })
                    this.getOneSIMOrderListHandler();                    
                }
            })


        },
        updateStateHandler(iccid, showSuccessMsg){
            var data = { iccid };
            updateState(data).then(res => {
                if(res.data.code == 200){
                    if(showSuccessMsg){
                        this.$message.success(res.data.message);
                    }
                    getSimDetailInfo(data).then(res => {
                        if(res.data.code == 200){
                            this.showDetail = true;
                            var result = res.data;
                            for(var key in this.cardInfo){
                                this.cardInfo[key] = res.data.data[key];
                            }
                        }
                    });
                }else{
                    this.$message.error(res.data.message);
                }
            })            
        },
        getOneSIMOrderListHandler(){
            var data = {
                iccid: this.cardDetailsForm.iccid
            }
            getOneSIMOrderList(data).then(res => {  //获取往期来往订单
                if(res.data.code == 200){
                    var result = res.data.data;
                    this.tableData = result.resultList;
                    this.total = result.totalNum;
                    this.currentPage = result.pageNo;
                    this.pageSize = result.perPageNum;                       
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },             
        showAddPkg(){            
            var data = {
                iccid: this.cardInfo.iccid
            }            
            getAgentPkgList(data).then(res => {
                var result = res.data.data;
                if(res.data.code == 200){
                    if(result.length > 0){
                        this.addPkgVisible = true;
                        this.pkgList = result;
                        this.showFlag = result[0].isNextMonth == 10;                        
                    }else{
                        this.$message.error('该套餐组下无可添加的套餐！')
                    }                    
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },        
        sureAddPkgHandle(){
            var data = this.addPkgForm;
            data.iccid = this.cardInfo.iccid
            agentAddPkg(data).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                    this.addPkgVisible = false;
                    this.getSimDetailInfoHandler(this.cardInfo.iccid); 
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },      
        showToNewCardHandler(){
            this.toNewCardVisible = true;
        },
        sureToNewCardHandler(){
            this.$refs.toNewCardForm.validate(valid => {
                if(valid){
                    var data = {
                        oldIccid: this.cardInfo.iccid,
                        newIccid: this.toNewCardForm.iccid,
                        moveType: this.toNewCardForm.moveType,
                        remark: this.toNewCardForm.remark
                    }
                    toNewCard(data).then(res => {
                        if(res.data.code == 200){
                            this.toNewCardVisible = false;
                            this.$message.success('转卡成功！');
                            this.getSimDetailInfoHandler(this.cardInfo.iccid)
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })
                }
            })
        },
        simDiagnosisHandler(){
            this.$confirm("您确定使用一键诊断功能吗？", "提示" ,{          
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then( () => {
                var data = {
                    iccid: this.cardInfo.iccid
                }
                simDiagnosis(data).then( res => {
                    if(res.data.code == 200){
                        this.$message.success("诊断完成！");
                        this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    }else{
                        this.$message.success(res.data.message);
                    }
                })
            })   
        },
        stateRecordListPageHandle(){
            this.stateRecordVisible = true;
        },
        dayFluxDetailHandle(){
            this.dayFluxVisible = true;
        },

        IllusoryCardState(row){
            if(row.cardState >= 5 && row.cardState != 11){//异常或违禁
                if(row.cardState == 12){
                  return '注销'
                }else if(row.cardState == 9){
                  return '故障'
                }
                return '正常';
            }else{
                return row.cardStateName;
            }
        },

        handleSizeChange(val){
            this.pageSize = val;
        },
        handleCurrentChange(val){
            this.currentPage = val;
        }  
    },
    mounted () {
        var fromPage = this.$store.state.menu.fromPage;
        var fromPageIccid = this.$store.state.menu.fromPageIccid;
        if(fromPage == 'cardList'){
            this.cardDetailsForm.iccid = fromPageIccid;
            this.getSimDetailInfoHandler(this.cardDetailsForm.iccid);
            this.$store.commit('menu/setFromPage', '');
            this.$store.commit('menu/setFromPageIccid', '');
        }        
    },
    // 指令
    directives: {
        focus: {
            inserted: function (el) {
                function getFocus(element){
                    if(element.nodeName === 'INPUT'){
                        element.focus();
                    }else if(element.children.length > 0){
                        for(let i=0; i<element.children.length; i++){
                            getFocus(element.children[i])
                            return;
                        }
                    }
                }
                getFocus(el);
            }
        }
    }
}
</script>

<style lang="less">
#cardInfo {
    font-size: 12px;

    .section1, .section2,.section3,.section4,.section5 {
        margin-bottom: 30px;  
        padding-left: 8px;
    }
    .section2 {
        .el-row {
            line-height: 40px;
        }
    }
    .section3 {
        .el-row {
            line-height: 34px;
            margin-bottom: 20px;
        }
        
        .progressOuter {
            line-height: normal;
            .el-progress {
                margin: 5px 0;
            }
        }

    }
    .section4 {
        div {
            .el-button {
                margin-right: 30px;             
            }
        }
    }
    h4 {
        font-size: 13px;
        font-weight: bold;
        padding-left: 5px;
        margin-bottom: 20px;
        margin-left: -8px;
        border-left: 3px solid #409eff;
    }



    /*新增套餐*/
    .pkgName {
        display: block;
        label.el-radio {
            width: 50%;
            margin: 10px 0 15px 0;
        }
    }

    .span-defined{
        margin-right: 20px;
    }

    .font-defined{
        font-size:24px;
    }

    .green{
        color:#309200;
    }

    .red{
        color:#c71c1c;
    }

    .dark{
        color:#7d7d5d;
    }
}
</style>

